import { v4 as uuidv4 } from 'uuid';

/**
 * Tags a stream URL with the browser watching it, so mediaserver-api can tell duplicates
 * apart. MediaMTX cannot: two tabs of one browser share an IP and a user agent, and it
 * reports only those plus the query string - which it hands back verbatim per session.
 *
 * `cid` is one id per browser profile, shared by its tabs and windows. Same key and
 * meaning as the shared WHEP session registry (SCO-2682), so both send the same value.
 */
const CLIENT_ID_STORAGE_KEY = 'whepClientId';

export const CLIENT_ID_PARAM = 'cid';

const readOrCreateClientId = (): string => {
  try {
    const existing = localStorage.getItem(CLIENT_ID_STORAGE_KEY);
    if (existing) return existing;
    const created = uuidv4();
    localStorage.setItem(CLIENT_ID_STORAGE_KEY, created);
    return created;
  } catch {
    // Storage blocked: this page still gets a tag, it just reads as its own browser.
    return uuidv4();
  }
};

const clientId = readOrCreateClientId();

/** This browser's `cid`, as sent with its stream URLs. */
export const getViewerClientId = (): string => clientId;

/** Adds `cid` to an absolute stream URL; anything unparseable is returned as is. */
export const addViewerTagToUrl = (url: string): string => {
  if (!url) return url;
  try {
    const tagged = new URL(url);
    tagged.searchParams.set(CLIENT_ID_PARAM, clientId);
    return tagged.href;
  } catch {
    return url;
  }
};
